module.exports = "pegasus_template/assets/hexline-youtube.gif";